import { get } from "../../helpers/api";

import { LoginQrCodeData } from "./types";

export async function getLoginQrCodeData(): Promise<LoginQrCodeData> {
  return get("/schools/qr-code-login");
}
